<template>
    <div class="allchain project-approval-page">
        <!-- 页面标题 -->
    <div class="page-header">
      <div class="header-left">
        <i class="el-icon-s-order"></i>
        <h2>全国企业拿地项目库</h2>
      </div>
    </div>
        <div class="index_left_centerpage">
            <div class="whitebox right_topbox">
                <div class="right_boxtitle map_title_tab">
                    <!-- ajaxsearchcompany(1) -->
                    <span class="title" :class="{ 'current': navValue == list.value }" @click="navOnclick(list.value);"
                        v-for="(list) in navList" :key="list.value">{{ list.label }}</span>
                </div>
                <landStatictics class="mt-3" :pageType="navValue" @search="searchList"></landStatictics>
            </div>
            <div class="whitebox">
                <div class="pb-3 pt-2" v-loading="loading">
                    <table border="0" cellspacing="0" cellpadding="0" class="land_table">
                        <tr>
                            <th>名次</th>
                            <th v-show="navValue != 3">{{ navValue == 1 ? '行业' : '区域' }}</th>
                            <th v-show="navValue == 3">企业名称</th>
                            <th v-show="navValue == 3">所在区域</th>
                            <th>拿地面积（亩）</th>
                            <!-- <th>拿地面积占比</th> -->
                            <th>拿地金额</th>
                            <!-- <th>拿地金额占比</th> -->
                            <th>拿地数量</th>
                        </tr>
                        <tr v-for="(item, index) in enterpristlist" :key="item.stockcode">
                            <td>{{ (page - 1) * pageSize + index + 1 }}</td>
                            <td v-show="navValue != 3">{{ item.name || '-' }}</td>
                            <td v-show="navValue == 3">{{ item.title || '-' }}</td>
                            <td v-show="navValue == 3">{{ item.name || '-' }}</td>
                            <td>{{ item.size.toFixed(2) }}</td>
                            <td>{{ item.money }}</td>
                            <!-- <td>{{item.purpose}}</td> -->
                            <td>{{ item.num }}</td>
                            <!-- <td>{{item.sourceEnterprise || '-'}}</td> -->
                            <!-- <td>{{item.sourceArea|| '-'}}</td> -->
                        </tr>
                    </table>
                </div>
                <!-- 分页 -->
                <div class="pagination-wrapper oh w95mg py-3" v-if="totalPage > 1">
                    <el-pagination class="fr" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="page" :page-sizes="[20]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="total" background />
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import landStatictics from "./inc/landStatictics.vue";
export default {
    name: 'landSearch',
    components: {
        landStatictics
    },
    computed: {
        ...mapState({
            // isCollapse: (state) => state.app.isCollapse,
            isCollapse: (state) => state.isCollapse,
        }),
        ...mapGetters(['isCollapse'])
    },
    data() {
        return {
            title: "",
            curWebsite: this.$api.getWebsiteType(),
            userdata: {},
            yj_itemcode: "E02",
            page: 1, //显示的是哪一页
            haspage: true, //是否还有下一页
            pageSize: 20, //每一页显示的数据条数
            total: 0, //记录总数
            totalPage: 1,
            maxPage: 10, //最大页数 
            enterpristlist: [],
            navList: [
                { value: 1, label: '项目行业分布' },
                { value: 2, label: '项目区域分布' },
                { value: 3, label: '企业统计分析' },
            ],
            navValue: 1,
            searchData: {},
            loading: false,
        }
    },
    created() {

    },
    mounted() {
        this.ajaxsearchcompany(1);
    },
    methods: {
        navOnclick(value) {
            this.navValue = value;
            // this.ajaxsearchcompany(1);
        },
        searchList(filterData) {
            //处理一下filterData里面为‘’和0的数据
            for (let key in filterData) {
                if (filterData[key] == '' || filterData[key] == 0) {
                    delete filterData[key];
                }
            }
            this.searchData = filterData;
            console.log('this.searchData', this.searchData);
            // return;
            this.ajaxsearchcompany(1);
        },
        addClue(item) {
        },
        ajaxsearchcompany(pages) {
            this.page = pages ? pages : 1;
            this.loading = true;
            let params = {
                page: this.page,
                // thread:this.navValue == 1 ? '0' : '1',
                pageSize: this.pageSize,
                ...this.searchData
            };
            let ajxurl = this.$api.metall.LandCount.Industry();
            if (this.navValue == 1) {
                this.$api.metall.LandCount.Industry();
            } else if (this.navValue == 2) {
                ajxurl = this.$api.metall.LandCount.Area();
            } else if (this.navValue == 3) {
                ajxurl = this.$api.metall.LandCount.Enterprise();
            }
            this.$axios.get(ajxurl, { params: params }).then((res) => {
                if (res.success) {
                    this.enterpristlist = res.list;
                    this.totalPage = res.totalPage;
                    this.total = res.totalRecord;
                    this.pageSize = res.pageSize;
                    this.loading = false;
                } else {
                       this.$message.error(res.msg);
                    this.loading = false;
                }
            }).catch((err) => {
                this.loading = false;
            });
        },
        // 分页
        handleSizeChange(val) {
            this.pageSize = val
            this.ajaxsearchcompany()
        },

        handleCurrentChange(val) {
            this.page = val
            this.ajaxsearchcompany(val);
        }
    },
}
</script>

<style lang="scss">
.projectFormIcon {
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 20px;

    &:before {
        content: "";
        display: inline-block;
        width: 16px;
        height: 16px;
        background-color: #3a568e;
        margin-right: 20px;
        border-radius: 4px;
    }
}

.collectfont1 {
    font-size: 14px;
    color: #305ea3;
    cursor: pointer;

    &:hover {
        color: #f19d00;
    }
}

.land_table {
    margin: 0 auto;
    border: 1px solid #f2f2f2;
    background: #fff;
    width: 95%;
    font-size: 14px;

    .title {
        cursor: pointer;
        color: #305ea3;

        &:hover {
            color: #f19d00;
            text-decoration: underline;
        }
    }

    th {
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        height: 54px;
        line-height: 54px;
        background: #f2f8fe;
        white-space: nowrap;
        padding: 0 10px;
        border-right: 1px solid #dcdcdc;
    }

    tr {
        height: 40px;
        border-bottom: 1px solid #dcdcdc;

        td {
            text-align: center;
            border-right: 1px solid #dcdcdc;
            padding: 0 10px;
            border-bottom: 1px solid #dcdcdc;
        }
    }
}
</style>